import { render, staticRenderFns } from "./EventDiikuti.vue?vue&type=template&id=150f4b66"
import script from "./EventDiikuti.vue?vue&type=script&lang=js"
export * from "./EventDiikuti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports